import { Component } from '@angular/core';

import { GloControlComponent } from "../../../shared/components/glo-control/glo-control.component";
import { environment } from '../../../../environments/environment';

@Component({
    selector: 'business-appointment-add',
    imports: [GloControlComponent],
    templateUrl: './appointment-add.component.html',
    styleUrl: './appointment-add.component.scss'
})
export class BusinessAppointmentAddComponent {
    assetUrl = environment.assetBaseUrl
}
